import React, { useCallback } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { emit } from '@acorns/admin-portal-bridge'

import { Icon } from '../Icon'

export type Props = {
  href: string
  icon: string
  selected?: boolean
  /**
   * Optional target attribute (e.g. '_blank') – when supplied OR when `href` is an
   * absolute URL we render a regular anchor tag instead of a react-router `Link`.
   */
  target?: string
}

const NavLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`

const ExternalLink = styled.a`
  color: inherit;
  text-decoration: none;
`

export const Item: React.SFC<Props> = (props) => {
  const isExternal = props.href.startsWith('http') || Boolean(props.target)

  const handleClick = useCallback((event) => {
    if (isExternal) return

    const framedRenderer = document.getElementById('framed_renderer') as HTMLIFrameElement

    if (!event.metaKey && framedRenderer) {
      event.preventDefault()

      // TODO: Remove this when order processing is moved to it's own separate app
      emit(framedRenderer.contentWindow, 'navigationRequest', {
        pathname: event.currentTarget.pathname,
      })
    }
  }, [isExternal])

  return (
    <li>
      {isExternal ? (
        <ExternalLink href={props.href} target={props.target} rel={props.target === '_blank' ? 'noopener noreferrer' : undefined}>
          <Icon icon={props.icon} selected={props.selected} />
        </ExternalLink>
      ) : (
        <NavLink to={props.href} onClick={handleClick}>
          <Icon icon={props.icon} selected={props.selected} />
        </NavLink>
      )}
    </li>
  )
}
